export const mappingProductsByCategory = (info: any) => {
    let prodt:any[] = [];
  
    info.forEach((category: any) => {
      category.categoria.forEach((pro: any) => {
        if (pro.producto.length > 0) {
          prodt = [...prodt, ...pro.producto]
        }
      })
    });
  
    return prodt;
  }